module.exports = __webpack_public_path__ + "img/Bulela.dbf16803.jpeg";